import { useState } from "react";
import { Button, Input, Label, TextField } from "@heroui/react";

import { useLabelExports } from "@/features/courier/hooks/use-label-exports.ts";

export const CourierPrintStickers = () => {
  const [count, setCount] = useState<number>(1);

  const { mutateAsync, isPending } = useLabelExports();

  return (
    <div className="flex flex-col gap-4 p-4">
      <p className="text-neutral-600 font-medium">Наклейки для курьера</p>

      <TextField>
        <Label>Кол-вол</Label>
        <Input
          className="bg-white"
          defaultValue="1"
          disabled={isPending}
          max={50}
          type="number"
          value={`${count}`}
          onChange={(e) => setCount(Number(e.target.value))}
        />
      </TextField>

      <Button
        className="mt-auto"
        isPending={isPending}
        onPress={() => mutateAsync({ count })}
      >
        Распечатать
      </Button>
    </div>
  );
};
